module.exports = __webpack_public_path__ + "static/img/equip1.71d33a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coreValues/equip1.png
// module id = WAGS
// module chunks = 2